<template>
  <!-- 系列视频 -->
  <div class="series-video">
    <div class="top-box">
      <div class="articel-title">
        <img src="@static/images/product/articelTag.png" alt="" />
        <span>{{ detail.title }}</span>
      </div>
      <div class="tag-list" v-if="detail.label && detail.label.length">
        <div class="tag" v-for="text in detail.label" :key="text">{{ text }}</div>
      </div>
    </div>
    <div class="content-box" v-if="videoList.length">
      <div class="video-list-box" :style="{ height: videoH + 'px' }">
        <div class="box-title">课程目录</div>
        <div class="video-list">
          <div
            class="video-item"
            :class="{ active: bean.materialUrl == curVideo.materialUrl }"
            v-for="bean in videoList"
            :key="bean.materialUrl"
            @click="selectVideo(bean)"
          >
            <div class="text1">{{ bean.materialName }}</div>
            <div class="text2">
              <div>{{ bean.updateTime }}</div>
              <div class="time2">时长：{{ bean.duration }}</div>
            </div>
            <div class="btn-list">
              <!-- 下载 -->
              <i class="iconfont icon-xiazai" @click="downloadVideo(bean)"></i>
              <!-- 暂停 -->
              <i class="iconfont icon-bofangzhong" v-if="bean.materialUrl == curVideo.materialUrl && !paused"></i>
              <!-- 播放 -->
              <i class="iconfont icon-bofang" v-else></i>
            </div>
          </div>
        </div>
      </div>
      <div class="video-main">
        <div class="video-box" v-if="curVideo.materialUrl" id="videoBox">
          <video
            id="myVideo"
            class="video"
            :src="curVideo.materialUrl"
            controls
            :poster="curVideo.coverImg"
            controlslist="nodownload"
            x5-playsinline
            playsinline
            webkit-playsinline
            x-webkit-airplay
            muted
            autoplay
            @play="getVideoStatus"
            @pause="getVideoStatus"
          ></video>
        </div>
      </div>
    </div>
    <div class="intro-box">
      <el-button class="download-btn" type="primary" @click="downloadCourseware()" v-if="detail.courseInfo && detail.courseInfo.length">下载课件</el-button>
      <div class="box-title">课程介绍</div>
      <div class="intro-text" v-html="detail.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    tabIndex: 1,
    detail: {},
    videoList: [],
    videoH: '',
    paused: false, // 视频是否暂停
    curVideo: {}
  }),
  watch: {},
  mounted() {
    this.id = this.$route.query.id;
    this.getData();
    window.addEventListener('resize', this.getVideoH);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getVideoH);
  },
  methods: {
    getVideoH() {
      this.videoH = document.getElementById('videoBox')?.offsetHeight;
    },
    // 获取视频播放状态
    getVideoStatus() {
      this.paused = document.getElementById('myVideo')?.paused;
    },
    // 获取文章详情
    getData() {
      this.$http({
        url: '/master/information/queryArticleDetail',
        type: 'get',
        params: {
          articleId: this.id
        }
      }).then(res => {
        const data = res.data;
        if (data.label) {
          data.label = data.label.split(',');
        } else {
          data.label = [];
        }
        this.videoList = data.videoList ? JSON.parse(data.videoList) : [];
        data.courseInfo = data.courseInfo ? JSON.parse(data.courseInfo) : [];
        if (this.videoList.length) {
          this.selectVideo(this.videoList[0]);
        }
        this.detail = data;
        this.$nextTick(() => {
          this.getVideoH();
        });
      });
    },
    // 下载课件
    downloadCourseware() {
      const list = [
        {
          type: 3,
          articleId: this.id
        }
      ];
      this.$tools.daochu('/master/information/downloadFile', { list }, 'put');
    },
    goBack() {
      this.$router.go(-1);
    },
    downloadVideo(data) {
      let base = location.origin;
      if (this.$config.env == 2) {
        //本地
        base = 'https://fqyf.wts9999.net';
      }
      location.href = base + '/api/common/downloadByUrl?url=' + (data.downMaterialUrl || data.materialUrl);
    },
    selectVideo(item) {
      if (item.materialUrl == this.curVideo.materialUrl) {
        // 点击当前视频切换视频播放状态
        const myVideo = document.getElementById('myVideo');
        const paused = myVideo.paused; //播放状态
        if (paused) {
          myVideo.play();
        } else {
          myVideo.pause();
        }
      } else {
        this.curVideo = item;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import './seriesVideo.scss';
</style>
